<div class="grid" *ngIf="fields && fields.length > 0">
    <ng-container *ngFor="let field of fields">

        <!-- tipos delegados en el padre (adjuntos) -->
        <ng-container *ngIf="isParentType(field) && isVisible(field) && extraTemplate">
            <ng-container *ngTemplateOutlet="extraTemplate; context: { $implicit: field }"></ng-container>
        </ng-container>

        <!-- campos de formulario -->
        <div class="input-field {{field.colClass || 'col-12'}}" *ngIf="isVisible(field) && !isParentType(field)">
            <label [for]="field.code">{{field.label}}<ng-container *ngIf="field.required"> *</ng-container></label>

            <!-- select -->
            <p-dropdown *ngIf="field.type=='select'" [(ngModel)]="data[field.code]"
                        [options]="getOptions(field)" [optionLabel]="field.optionLabel || 'label'" [optionValue]="field.optionValue || 'value'"
                        appendTo="body" placeholder="Selecciona una opción" showClear styleClass="sm"
                        [required]="field.required" (onChange)="onChange(field)">
                <ng-template let-option pTemplate="item">
                    <div class="flex flex-column">
                        <span>{{option[field.optionLabel || 'label']}}</span>
                        <small class="text-color-secondary white-space-normal" *ngIf="option.description">{{option.description}}</small>
                    </div>
                </ng-template>
            </p-dropdown>

            <!-- número de servicio/aviso: desplegable si hay avisos, si no input libre -->
            <ng-container *ngIf="field.type=='notificationNumber'">
                <p-dropdown *ngIf="context.notificationNumbers && context.notificationNumbers.length>0" [(ngModel)]="data[field.code]"
                            [options]="context.notificationNumbers" optionLabel="displayInfo" optionValue="code"
                            appendTo="body" placeholder="Selecciona una opción" showClear styleClass="sm"
                            [required]="field.required" (onChange)="onChange(field)"></p-dropdown>
                <input *ngIf="!context.notificationNumbers || context.notificationNumbers.length==0" pInputText [(ngModel)]="data[field.code]" [required]="field.required" />
            </ng-container>

            <!-- text -->
            <input *ngIf="field.type=='text'" pInputText [(ngModel)]="data[field.code]" [required]="field.required" />

            <!-- textarea -->
            <textarea *ngIf="field.type=='textarea'" pInputTextarea rows="3" [(ngModel)]="data[field.code]" [required]="field.required"></textarea>

            <!-- number -->
            <p-inputNumber *ngIf="field.type=='number'" [(ngModel)]="data[field.code]"
                           [useGrouping]="field.numberFormat?.useGrouping || false"
                           [minFractionDigits]="field.numberFormat?.minFractionDigits || 0"
                           [maxFractionDigits]="field.numberFormat?.maxFractionDigits || 0"
                           [required]="field.required"></p-inputNumber>

            <!-- date -->
            <p-calendar *ngIf="field.type=='date'" [firstDayOfWeek]="1" [(ngModel)]="data[field.code]"
                        [showIcon]="true" [showTime]="false" dateFormat="dd/mm/yy" appendTo="body" [required]="field.required"></p-calendar>

            <!-- datetime -->
            <p-calendar *ngIf="field.type=='datetime'" [firstDayOfWeek]="1" [(ngModel)]="data[field.code]"
                        [showIcon]="true" [showTime]="true" [hourFormat]="'24'" [stepMinute]="5" dateFormat="dd/mm/yy" appendTo="body" [required]="field.required"></p-calendar>

            <!-- checkbox -->
            <p-checkbox *ngIf="field.type=='checkbox'" [(ngModel)]="data[field.code]" [binary]="true" (onChange)="onChange(field)"></p-checkbox>

            <!-- ayuda fija del campo y ayuda de la opción seleccionada -->
            <small class="text-color-secondary" *ngIf="field.hint">{{field.hint}}</small>
            <small class="text-color-secondary" *ngIf="getSelectedOptionDescription(field)">{{getSelectedOptionDescription(field)}}</small>
        </div>

    </ng-container>
</div>
